import {loadStripe} from "@stripe/stripe-js";



const fonts = [
  {
    family: 'Euclid Galactic',
    src: 'url(https://www.virgingalactic.com/assets/fonts/EuclidGalactic-2G-WebXL.woff2)',
    weight: '400',
  },
  {
    family: 'Euclid Galactic',
    src: 'url(https://www.virgingalactic.com/assets/fonts/EuclidGalactic-3G-WebXL.woff2)',
    weight: '500',
  },
]
const StripeInit = async (clientSecret, publishableKey, appearance, domElement = '#checkout') => {
  console.log('initializing stripe ', publishableKey);

  const stripePromise = loadStripe(publishableKey).catch((error) => {
    console.error(error)
  })

  const stripe = await stripePromise

  console.log('stripe 2', stripe);
  const elements = stripe.elements({clientSecret, appearance, fonts})
  const paymentElement = elements.create('payment')
  paymentElement.mount(domElement);

  return {stripe, elements}
}

export async function useStripe(clientSecret, publishableKey, appearance, domElement) {
  return await StripeInit(clientSecret, publishableKey, appearance, domElement);
}
